// extracted by mini-css-extract-plugin
module.exports = {"container":"BackButton-module__container--2ixVm","icon":"BackButton-module__icon--3a2GS","text":"BackButton-module__text--3kgd-"};